// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"0e1e2208f9229d5fb2a2","117":"22676ee6445f80c1c652","118":"d1de0ac8a0fae51869a6","173":"0fa5939bae6fd3069859"}[chunkId] + ".chunk.js";
};